// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { ImageSourcePropType } from 'react-native';

import { getAssetImageSource } from '@/services/assetImageSource';

const HoleIllustration = getAssetImageSource('images/hole.png', 'hole-background', '/round/[roundId]/hole/[hole]');
const WaterIcon = getAssetImageSource('images/water.png', 'icon', '/round/[roundId]/hole/[hole]');
const BunkerIcon = getAssetImageSource('images/bunker.png', 'icon', '/round/[roundId]/hole/[hole]');
const PenaltyIcon = getAssetImageSource('images/penalties.png', 'icon', '/round/[roundId]/hole/[hole]');
const ThreePuttIcon = getAssetImageSource('images/threeputt.png', 'icon', '/round/[roundId]/hole/[hole]');
const MysteryPrizeIcon = getAssetImageSource('images/mystery.png', 'icon', '/round/[roundId]/hole/[hole]');
const GolfballIcon = getAssetImageSource('images/golfball.png', 'icon', '/round/[roundId]/hole/[hole]');
const BirdieImage = getAssetImageSource('images/birdie.png', '', '/round/[roundId]/hole/[hole]', {
  width: 512,
  height: 512,
  bucketStep: 1,
});
const BestBallSelectImage = getAssetImageSource('images/games/best-ball-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const BunkerSelectImage = getAssetImageSource('images/games/bunker-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const HighLowSelectImage = getAssetImageSource('images/games/high-low-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const MysterySelectImage = getAssetImageSource('images/games/mystery-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const SkinsSelectImage = getAssetImageSource('images/games/skins-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const StablefordSelectImage = getAssetImageSource('images/games/stableford-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const WaterSelectImage = getAssetImageSource('images/games/water-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const WorstBallSelectImage = getAssetImageSource('images/games/worst-ball-select.png', 'game-select', '/round/[roundId]/hole/[hole]');
const ScoreButtonImage = getAssetImageSource('images/button-score.png', 'button', '/round/[roundId]/hole/[hole]');
const ScoreButtonSelectedImage = getAssetImageSource('images/button-score-clicked.png', 'button', '/round/[roundId]/hole/[hole]');
const TrophyImage = getAssetImageSource('images/trophy.png', 'icon', '/round/[roundId]/hole/[hole]');
const TrophyOnlyImage = getAssetImageSource('images/trophy_only.png', 'icon', '/round/[roundId]/hole/[hole]');
const PuttButtonImage = getAssetImageSource('images/button-putt.png', 'button', '/round/[roundId]/hole/[hole]');
const ScorePopupShortButtonImage = getAssetImageSource('images/short_button.png', '', '/round/[roundId]/hole/[hole]', { width: 203, height: 62, bucketStep: 1 });
const ScorePopupLargeButtonImage = getAssetImageSource('images/large_button.png', '', '/round/[roundId]/hole/[hole]', { width: 100, height: 50, bucketStep: 1 });
const ScorePopupLongButtonImage = getAssetImageSource('images/long_button.png', '', '/round/[roundId]/hole/[hole]', { width: 430, height: 85, bucketStep: 1 });
const ScorePopupRailBannerImage = getAssetImageSource(
  'images/long_Banner.png',
  '',
  '/round/[roundId]/hole/[hole]',
  { width: 60, height: 480, bucketStep: 1 },
);
const LeftButtonImage = getAssetImageSource('images/left_button.png', '', '/round/[roundId]/hole/[hole]', { width: 80, height: 80, bucketStep: 1 });
const LeftButtonDisabledImage = getAssetImageSource('images/left_button-disabled.png', '', '/round/[roundId]/hole/[hole]', { width: 80, height: 80, bucketStep: 1 });
const RightButtonImage = getAssetImageSource('images/right_button.png', '', '/round/[roundId]/hole/[hole]', { width: 80, height: 80, bucketStep: 1 });

const GAME_ICON_MAP: Record<string, ImageSourcePropType> = {
  'best-ball': BestBallSelectImage,
  bunker: BunkerSelectImage,
  'high-low': HighLowSelectImage,
  mystery: MysterySelectImage,
  skins: SkinsSelectImage,
  stableford: StablefordSelectImage,
  water: WaterSelectImage,
  'worst-ball': WorstBallSelectImage,
};

export {
  BirdieImage,
  BestBallSelectImage,
  BunkerIcon,
  BunkerSelectImage,
  GAME_ICON_MAP,
  GolfballIcon,
  HighLowSelectImage,
  HoleIllustration,
  MysteryPrizeIcon,
  MysterySelectImage,
  PenaltyIcon,
  PuttButtonImage,
  ScoreButtonImage,
  ScoreButtonSelectedImage,
  ScorePopupLargeButtonImage,
  LeftButtonImage,
  LeftButtonDisabledImage,
  RightButtonImage,
  ScorePopupLongButtonImage,
  ScorePopupRailBannerImage,
  ScorePopupShortButtonImage,
  SkinsSelectImage,
  StablefordSelectImage,
  ThreePuttIcon,
  TrophyImage,
  TrophyOnlyImage,
  WaterIcon,
  WaterSelectImage,
  WorstBallSelectImage,
};
